import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'

export const getProductsListThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.getProductsList, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const searchProductsThunk = async (body) => {
	try {
		const response = await customAxios[apiMethods.post](apiEndPoints.searchProducts, body)
		return { data: response.data }
	} catch (error) {
		throw error
	}
}

export const fetchProductsByCategory = async (categoryId) => {
	try {
		const response = await fetch(`/api/products?category=${categoryId}`) // Adjust endpoint as needed
		if (!response.ok) {
			throw new Error('Failed to fetch products')
		}
		const data = await response.json()
		return data.products // Assuming API response contains a `products` array
	} catch (error) {
		console.error('Error fetching products:', error)
		return []
	}
}
